import axios from 'axios'

const apiInventoryClient = axios.create({
    baseURL: process.env.REACT_APP_API_INVENTORY_URL,
    timeout: 60000,
    headers: {
        'Content-Type': 'application/json'
    }
})

apiInventoryClient.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('authToken')
        if (token) {
            config.headers.Authorization = `Bearer ${token}`
        }
        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

export default apiInventoryClient
